import Controller from '../abstracts/Controller';
import 'scss-templates/t-faq.scss';

export default class YextFaqController extends Controller {

  static get COMPONENTS() {
    return [
      'FaqComponent'
    ];
  }

  init() {
    super.init();
  }
}
